export const SCROLL_DELAY_MS = 200;

export const ADDED_FIELD_LABEL = 'Added';
